module.exports = __webpack_public_path__ + "static/fundamental1-02aabc8dc2df66433b1df0643d36442a.jpg";